module.exports = __webpack_public_path__ + "img/image1_en.58bed481.png";